import './index.css'

function TagGradient({text}){
    return <div className='homepage-tag small-text'>{text}</div>
}

export default TagGradient